import { useHistory } from "react-router-dom";
import { logout } from "../context/actions/authActions";
import { useAuthDispatch } from "../context/AuthContext";
import axios from "../network/ApiConfig";
import { toastFail } from "./toast";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

const useApiService = () => {
  const dispatch = useAuthDispatch();
  const history = useHistory();

  const putMethod = async <T = any>(
     url: any,
     payload?: any,
     config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> => {
     const res = await axios.put(url, payload, config).catch((err) => {
        if (err.response?.status === 401) {
           toastFail('Please login');
           logout(dispatch);
        } else if (err.response?.status === 403) {
           toastFail('You are not allowed to enter here !');
           history.push('/');
        }
        return err;
     });
     return res;
  };

  const patchMethod = async <T = any>(
    url: any,
    payload?: any,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> => {
    const res = await axios.patch(url, payload, config).catch((err) => {
      if (err.response?.status === 401) {
        toastFail("Please login");
        logout(dispatch);
      } else if (err.response?.status === 403) {
        toastFail("You are not allowed to enter here !");
        history.push("/");
      }
      throw err;
    });

    return res;
  };

  const getMethod = async <T = any>(
     url: any,
     payload?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> => {
     try {
        const res = await axios.get<AxiosRequestConfig, AxiosResponse<T>>(
           url,
           payload
        );
        return res;
     } catch (error) {
        const err = error as AxiosError;
        if (err.response?.status === 401) {
           toastFail('Please login');
           logout(dispatch);
        } else if (err.response?.status === 403) {
           toastFail('You are not allowed to enter here !');
           history.push('/');
        }
        throw err;
     }
  };

  const postMethod = async <T = any>(url: any, payload: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const res = axios.post(url, payload, config).catch((err) => {
      if (err.response.status === 401) {
        toastFail("Please login");
        logout(dispatch);
      } else if (err.response.status === 403) {
        toastFail("You are not allowed to enter here !");
        history.push("/");
      }
      throw err;
    });
    return res;
  };

  const deleteMethod = async (url: any) => {
    await axios.delete(url).catch((err) => {
      if (err.response?.status === 401) {
        toastFail("Please login");
        logout(dispatch);
      } else if (err.response?.status === 403) {
        toastFail("You are not allowed to enter here !");
        history.push("/");
      }
      throw err;
    });
  };

  return {
    putMethod,
    patchMethod,
    getMethod,
    postMethod,
    deleteMethod,
  };
};

export default useApiService;
